import { ImportStatus } from '@sonar-software/sonar-ts-constants';

function isSyncStatus(actualSyncStatus: string | null | undefined, expectedSyncStatus: string) {
	if (actualSyncStatus === expectedSyncStatus) {
		return true;
	}

	return false;
}

export function isSyncCompleted(status: string | null | undefined): boolean {
	return isSyncStatus(status, ImportStatus.Completed);
}

export function isSyncFailed(status: string | null | undefined): boolean {
	return isSyncStatus(status, ImportStatus.Failed);
}

export function isSyncInProgress(status: string | null | undefined): boolean {
	return isSyncStatus(status, ImportStatus.InProgress);
}

export function isSyncWaiting(status: string | null | undefined): boolean {
	return isSyncStatus(status, ImportStatus.Waiting);
}
